'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import TabContextProvider from '@/components/context/TabContext';
import { RegistrationProvider } from '@/components/context/RegistrationContext';

let browserQueryClient = undefined;

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  });
}

function getQueryClient() {
  if (typeof window === 'undefined') {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}

export default function ClientProviders({ children }) {
  const queryClient = getQueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <TabContextProvider>
        <RegistrationProvider>
          {children}
        </RegistrationProvider>
      </TabContextProvider>
    </QueryClientProvider>
  );
}
